import updateReport from '../../../../api/updateReport'
import { ActionHeaderIconeProps, ActionHeaderProps } from '../../../../common/components/CardEditor'
import { ReportContext } from '../../../../../src/app'
import React, { useContext, useState, useEffect } from 'react'
import styled from 'styled-components'
import LiveModal from 'live/components/ui/Modal'
import LiveSpan from '../../Content/LiveSpan'

import { PropsWidgetWrapper } from '../types'
import i18n from 'live/services/i18n'
import { GeneralTextInput } from '../../../../common/components/GeneralTextInput/generalTextInput'
import { PropsFilesPdfWrapper } from './types'
import { PDF } from '../../../../common/types/api/pdf'
import { TemplateModal } from '../../../../common/components/ConfigLookupReplicationButton/styles'
import { CustomToolTip } from '../../../../common/components/CustomToolTip/CustomToolTip'

const handlePdfRemoval = (s: string): string => {
    if (s !== null && s.includes('.pdf')) {
        return s.split('.pdf').shift()
    }
    return s
}

export default function ContentFileName({
    onHide,
    onChange,
    form
}: ActionHeaderProps<PropsFilesPdfWrapper>): JSX.Element {
    const [pdfFileName, setPdfFileName] = useState<string>(
        form.files[0] ? handlePdfRemoval(form.files[0]?.fileName) : 'file'
    )

    const onSave = () => {
        const currentPdf: PDF[] = []
        if (form.files === undefined || form.files.length == 0)
            currentPdf.push({
                fileName: pdfFileName,
                layout: []
            })
        else currentPdf.push({ ...form.files[0], fileName: pdfFileName })
        onChange({ ...form, files: currentPdf })
        onHide()
    }

    return (
        <TemplateModal show={true} onHide={onHide} animation={false} className="modal-sm" height={120}>
            <ModalContainer>
                <TemplateModal.Header>
                    <TemplateModal.Title>{i18n('Edit PDF file name')}</TemplateModal.Title>
                </TemplateModal.Header>
                <TemplateModal.Body>
                    <div>
                        <span className="spanText">File name:</span>
                    </div>
                    <GeneralTextInput
                        variant="primary"
                        editMode
                        onChange={e => setPdfFileName(e)}
                        value={pdfFileName ?? ''}
                        className="pdf-file-name-modal-input"
                    />
                    <div className="infoText">
                        <i className="far fa-info-circle" />
                        <div>{i18n('The file extension (.pdf) is added automatically')}</div>
                    </div>
                </TemplateModal.Body>
                <TemplateModal.Footer>
                    <TemplateModal.ModalActions
                        onSubmit={() => onSave()}
                        submitText={i18n('Save')}
                        submitBtnClassName="btn btn-primary saveButton"
                        cancelBtnClassName="discardButton"
                        onCancel={onHide}
                        cancelText={i18n('Cancel')}
                    />
                </TemplateModal.Footer>
            </ModalContainer>
        </TemplateModal>
    )
}

export function FileNameIcon({ onClick, form }: ActionHeaderIconeProps<PropsFilesPdfWrapper>): JSX.Element {
    const pdfFileName = form?.files[0]?.fileName ?? ''

    return (
        <StyledFileNameIcon onClick={() => onClick()}>
            <i className="fileNameIcon--icon far fa-file" />
            <div className="fileNameIcon__name">
                <span className="fileNameIcon__name--description">
                    {pdfFileName ? i18n('Current PDF File name: ') + ' ' : i18n(`PDF File name Configuration`)}
                </span>
                {pdfFileName && (
                    <span className="fileNameIcon__name--nameValue">{pdfFileName.split('.pdf').shift()}</span>
                )}
            </div>
        </StyledFileNameIcon>
    )
}

const StyledFileNameIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: ${({ theme }) => theme['font-regular']};

    .fileNameIcon {
        &--icon {
            /* margin: 4px; */
            color: ${({ theme }) => theme['blue-700']};
            font-size: 11px;
        }
        &__name {
            display: inline;
            /* margin-left: 8px; */
            span {
                line-height: normal;
            }

            &--description {
                color: ${({ theme }) => theme['blue-700']};
                font-weight: 600;
            }
            &--nameValue {
                color: ${({ theme }) => theme['blue-500']};
                font-weight: 400;
            }
            &--nameValue,
            &--description {
                font-size: 13px;
                font-style: normal;
                /* font-family: Source Sans Pro; */
                line-height: 16px; /* 123.077% */
            }
        }
    }
    :hover {
        * {
            cursor: pointer;
        }
    }
`

export const ModalContainer = styled.div`
    /* .pdf-file-name-modal-input {
        .textBlock {
            .primary_generalTextInput {
                margin: 0;
            }
        }
    } */
    .pdf-file-name-modal-input {
        input {
            margin: 2px 0px;
        }
        .textBlockBottomHelpText,
        .textBlockLabelHeader {
            margin: 0;
        }
    }
    .modal-body {
        .infoText {
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 12px;
            line-height: 16px;
            color: var(--gray-700);
            > i {
                padding: 2px;
                font-size: 10px;
            }
        }

        .spanText {
            font-family: ${({ theme }) => theme['font-semibold']};
        }
    }
`
